module.exports = __webpack_public_path__ + "static/img/Gallery01.e32a2e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery01.jpg
// module id = UfHY
// module chunks = 12